import { render, staticRenderFns } from "./prestamoVentaAdd.vue?vue&type=template&id=f0e8e1cc"
import script from "./prestamoVentaAdd.vue?vue&type=script&lang=js"
export * from "./prestamoVentaAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports